import React from 'react';
import { Outlet } from 'react-router-dom';

import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';

const BaseFrame = function () {
  return (
    <>
      <Header />
      <div id="container">
        <Outlet /> {/*Outletで呼び出されるコンポーネントにはcontainerより下のものを定義する*/}
      </div>
      <Footer />
    </>
  );
};

export default BaseFrame;
